import { IconProps } from './index';

const LoaderLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M2.636 15.364L4.05 13.95C5.19508 15.0952 6.70183 15.808 8.3135 15.9668C9.92518 16.1256 11.5421 15.7207 12.8887 14.821C14.2353 13.9214 15.2283 12.5826 15.6985 11.0329C16.1687 9.4832 16.087 7.81839 15.4673 6.32215C14.8477 4.82591 13.7284 3.59081 12.3002 2.8273C10.872 2.06379 9.22321 1.81911 7.63482 2.13495C6.04644 2.45078 4.61671 3.3076 3.58923 4.55941C2.56176 5.81121 2.00012 7.38055 2 9.00003H-1.90735e-06C1.52588e-05 6.91783 0.722006 4.90006 2.04295 3.29051C3.3639 1.68096 5.20206 0.579227 7.24426 0.173027C9.28645 -0.233173 11.4063 0.081295 13.2426 1.06285C15.079 2.0444 16.5181 3.63231 17.3149 5.55602C18.1117 7.47972 18.2169 9.6202 17.6124 11.6127C17.008 13.6053 15.7314 15.3266 14.0001 16.4834C12.2688 17.6402 10.19 18.1609 8.11779 17.9568C6.04562 17.7527 4.10832 16.8364 2.636 15.364Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default LoaderLine;
